import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const MainDashboard = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);


  return (
    <>
      <div className="w-full flex">
        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
        {/* header ,dashboard */}
        <div className="w-full lg:w-[83%] xl:w-5/6 ">
        <Header sidebarOpen={()=> setSidebarOpen(!sidebarOpen)}/>
          <main className="h-[88vh] bg-G20 overflow-y-auto vertical">{children}</main>
        </div>
      </div>
    </>
  );
};

export default MainDashboard;
